import { Icon, Spinner, Text } from '@dixa/lib-shared-habla';
import { getToolName, type DynamicToolUIPart, type ToolUIPart } from 'ai';

import styles from './mimSidekickToolPartIndicator.module.scss';

type MimSidekickToolPartIndicatorProps = {
  part: ToolUIPart | DynamicToolUIPart;
};

const isStringRecord = (value: unknown): value is Record<string, string> =>
  typeof value === 'object' &&
  value !== null &&
  !Array.isArray(value) &&
  Object.values(value).every((entry) => typeof entry === 'string');

export const MimSidekickToolPartIndicator = ({
  part,
}: MimSidekickToolPartIndicatorProps): JSX.Element => {
  const stateCopy = isStringRecord(part.toolMetadata?.stateCopy)
    ? part.toolMetadata?.stateCopy[part.state]
    : undefined;

  const { state } = part;
  const label = stateCopy ?? getToolName(part);

  const renderToolPartIndicator = (): JSX.Element => {
    const isLoading =
      state === 'input-streaming' || state === 'input-available';
    const isError = state === 'output-error';

    if (isLoading) {
      return (
        <>
          <Spinner size={12} />
          <Text.Paragraph variant="4">{`${label}…`}</Text.Paragraph>
        </>
      );
    }

    if (isError) {
      return (
        <>
          <Icon name="close" />
          <Text.Paragraph>
            {label} - {part.errorText ?? 'unknown error'}
          </Text.Paragraph>
        </>
      );
    }

    return (
      <>
        <Icon name="done" />
        <Text.Paragraph>{label}</Text.Paragraph>
      </>
    );
  };

  return (
    <div className={styles.toolIndicator}>{renderToolPartIndicator()}</div>
  );
};
